export enum FrequencyType {
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly'
}

export enum DayOfWeek {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday'
}

export interface PeriodSelector {
  frequency: FrequencyType;
  hour?: number; // Optional, only for Daily and Weekly
  dayOfWeek?: DayOfWeek; // Optional, only for Weekly
}
